import { render, staticRenderFns } from "./NmtSidebarProfileStats.vue?vue&type=template&id=19cbf653&scoped=true&"
import script from "./NmtSidebarProfileStats.vue?vue&type=script&lang=js&"
export * from "./NmtSidebarProfileStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cbf653",
  null
  
)

export default component.exports